import { render, staticRenderFns } from "./TradingOrderTradeItems.vue?vue&type=template&id=98b8070c&scoped=true&"
import script from "./TradingOrderTradeItems.vue?vue&type=script&lang=js&"
export * from "./TradingOrderTradeItems.vue?vue&type=script&lang=js&"
import style0 from "./TradingOrderTradeItems.vue?vue&type=style&index=0&id=98b8070c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b8070c",
  null
  
)

export default component.exports